import { Component, OnInit, Input, SimpleChanges, OnChanges, forwardRef, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, NG_VALIDATORS, Validator } from '@angular/forms';
import { NameAndAddressRecordType } from 'src/app/shared/common-components/AppConstants';
import { StateCountry, NameAndAddress, ShipmentPrefAddress } from 'src/app/shared/common-components/common-structure';
import { Observable } from 'rxjs';
import { RatesSroMasterService } from 'src/app/services/rates-sro-master/rates-sro-master.service';
import { filter } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { CommonValidators } from 'src/app/shared/common-components/common-validators';
import {ShipmentPreferredAddressesService} from '../../../services/shipment-preferred-addresses/shipment-preferred-addresses.service';
import {User} from '../../../services/user/user';

@Component({
    selector: 'app-shipment-address',
    templateUrl: './shipment-address.component.html',
    styleUrls: ['./shipment-address.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ShipmentAddressComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ShipmentAddressComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class ShipmentAddressComponent implements OnInit, OnChanges, ControlValueAccessor, Validator, AfterViewInit {
  @Input() address: NameAndAddress | ShipmentPrefAddress;
  @Input() states: StateCountry[];
  @Input() countries: StateCountry[];
  @Input() isPrimaryAddress = false;
  @Input() showDefaultAddress = false;
  @Input() isIssuingOffice = false;
  @Input() typeOfAddress;
  defaultAddress: NameAndAddress;
  showLocation: any;
  currentUser: User = JSON.parse(localStorage.currentUser);
  isCountrySelectedUSA: boolean;
  isRequiredAddress: boolean;
  dataShipperSearchAddressResults$: Observable<any>;
  shipmentPreferredAddresses: any;
  addressForm = new UntypedFormGroup({
    nameAddressId: new UntypedFormControl(''),
    shipmentsId: new UntypedFormControl(''),
    shipmentPrefAddressesId: new UntypedFormControl(''),
    recordType: new UntypedFormControl(''),
    defaultAddress: new UntypedFormControl(false),
    firstName: new UntypedFormControl('', [Validators.maxLength(45)]),
    lastName: new UntypedFormControl('', [Validators.maxLength(45)]),
    middleInitial: new UntypedFormControl('', [Validators.maxLength(1)]),
    addressLine1: new UntypedFormControl(''),
    addressLine2: new UntypedFormControl('', [Validators.maxLength(100)]),
    searchString: new UntypedFormControl(''),
    uspsCity: new UntypedFormControl(''),
    city: new UntypedFormControl('', [Validators.maxLength(45)]),
    state: new UntypedFormControl({ value: '', disabled: true }),
    stateId: new UntypedFormControl(''),
    zipCode: new UntypedFormControl('', [Validators.maxLength(6), CommonValidators.numeric]),
    countryId: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
    emailAddress: new UntypedFormControl(''),
    alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
    otherContactInfo: new UntypedFormControl(''),
    issuingOfficerTitle: new UntypedFormControl('', [Validators.maxLength(45)]),
    issuingOfficeName: new UntypedFormControl('', [Validators.maxLength(45)])
  });

  constructor(private ratesSroMasterService: RatesSroMasterService, private shipmentPreferredAddressesService: ShipmentPreferredAddressesService) {
    this.isRequiredAddress = false;
    this.addressForm.valueChanges.subscribe(value => {
      this.onChange(this.addressForm.getRawValue());
      this.onTouched();
    });
    this.dataShipperSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.addressForm.get('uspsCity').valueChanges.pipe(filter(value => value))
      .subscribe(uspsCity => {
        const state = this.states.find(stateDetails => {
          return stateDetails.stateCountryCode2Digit === uspsCity.stateAbbrev;
        });
        this.addressForm.get('city').setValue(uspsCity.cityName);
        this.addressForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
      });
    this.addressForm.get('countryId').valueChanges.pipe(filter(value => value)).subscribe(
      countryId => {
        this.isCountrySelectedUSA = countryId === 326;
        this.addressForm.get('city').reset();
        this.addressForm.get('zipCode').reset();
        this.addressForm.get('stateId').reset();
        this.addressForm.get('state').reset();
        if (this.isCountrySelectedUSA) {
          this.addressForm.get('city').disable();
          this.addressForm.get('zipCode').disable();
          if (this.isPrimaryAddress === false) {
            this.addFormElement('searchString');
          }
        } else {
          this.removeFormElement('searchString');
          if (this.isPrimaryAddress === false) {
            this.addressForm.get('city').enable();
            this.addressForm.get('zipCode').enable();
          }
        }
      }
    );
  }

  ngOnInit() {
    this.showLocation = this.currentUser.permissions === 'FRT';
    if (this.address.addressLine1 && this.address.addressLine1 && this.address.zipCode) {
      this.addressForm.patchValue(this.address, { emitEvent: false, onlySelf: true});
      this.addressForm.updateValueAndValidity();
    } else {
      this.shipmentPreferredAddressesService.getShipmentPrefAddressesById(this.currentUser.id, this.currentUser.organizationId,
          this.address.recordType, this.address.zipCode).subscribe(res => {
        this.shipmentPreferredAddresses = res;
        console.log(this.shipmentPreferredAddresses);
        this.defaultAddress = this.shipmentPreferredAddresses.find(addr => {
          return addr.defaultAddress === 1;
        });
        if (this.defaultAddress && !this.showDefaultAddress) {
          this.addressForm.patchValue(this.defaultAddress, {emitEvent: false, onlySelf: true});
          this.addressForm.updateValueAndValidity();
        } else {
          this.addressForm.get('addressLine1').reset();
          this.addressForm.get('addressLine2').reset();
          this.addressForm.get('phone').reset();
          this.addressForm.get('phoneExt').reset();
          this.addressForm.get('emailAddress').reset();
          this.addressForm.get('alternatePhone').reset();
        }
      });
    }
  }

  ngAfterViewInit() {
    const address = this.address as NameAndAddress;
    if (address.recordType === NameAndAddressRecordType.ISSUE_OFFICE && !address.shipmentsId) {
      setTimeout(() => {
        this.onChange(this.addressForm.getRawValue());
      });
    }
  }

  typeaheadAddressOnSelect($event) {
    const selectedAddress: ShipmentPrefAddress = $event.item;
    this.addressForm.get('addressLine1').setValue(selectedAddress.addressLine1);
    this.addressForm.get('addressLine2').setValue(selectedAddress.addressLine2);
    this.addressForm.get('emailAddress').setValue(selectedAddress.emailAddress);
    this.addressForm.get('firstName').setValue(selectedAddress.firstName);
    this.addressForm.get('lastName').setValue(selectedAddress.lastName);
    this.addressForm.get('middleInitial').setValue(selectedAddress.middleInitial);
    this.addressForm.get('otherContactInfo').setValue(selectedAddress.otherContactInfo);
    this.addressForm.get('phone').setValue(selectedAddress.phone);
    this.addressForm.get('phoneExt').setValue(selectedAddress.phoneExt);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.addressForm.reset();
    const address = changes['address'].currentValue as NameAndAddress;
    this.addressForm.get('phone').setValidators([Validators.minLength(10), Validators.maxLength(20), Validators.required]);
    this.addressForm.get('emailAddress').setValidators([Validators.maxLength(45), CommonValidators.email, Validators.required]);
    this.addressForm.get('addressLine1').setValidators([Validators.required, Validators.maxLength(100)]);
    this.addressForm.get('addressLine2').setValidators([Validators.required, Validators.maxLength(100)]);
    if (this.isPrimaryAddress === true) {
      this.addressForm.get('countryId').disable();
      this.removeFormElement('searchString');
      this.addressForm.get('city').disable();
      this.addressForm.get('zipCode').disable();
    } else {
      this.addressForm.get('countryId').enable();
      this.addressForm.get('city').enable();
      this.addressForm.get('zipCode').enable();
    }
    if (address.recordType === NameAndAddressRecordType.ISSUE_OFFICE) {
      this.addressForm.get('addressLine1').setValidators([]);
      this.addressForm.get('addressLine2').setValidators([]);
      this.addressForm.get('phone').setValidators([]);
      this.addressForm.get('emailAddress').setValidators([]);
      if (!address.shipmentsId) {
        this.addressForm.patchValue(address);
        return;
      }
    }
    if (!address) {
      return;
    }
    const countryId = address.countryId;
    this.isCountrySelectedUSA = countryId === 326;
    if (this.isCountrySelectedUSA) {
      this.addressForm.get('city').disable();
      this.addressForm.get('zipCode').disable();
      if (this.isPrimaryAddress === false) {
        this.addFormElement('searchString');
      }
    } else {
      this.removeFormElement('searchString');
      if (this.isPrimaryAddress === false) {
        this.addressForm.get('city').enable();
        this.addressForm.get('zipCode').enable();
      }
    }
    this.addressForm.patchValue(address, { emitEvent: false});
    this.onChange(this.addressForm.getRawValue());

    if (this.addressForm.get('recordType').value === 'Origin' ||
    this.addressForm.get('recordType').value === 'Bill To' ||
    this.addressForm.get('recordType').value === 'Destination') {
      this.isRequiredAddress = true;
    }
    // TODO re-enable this once default addresses functionality is fixed.
    /*if (this.defaultAddress && !this.showDefaultAddress) {
      this.addressForm.patchValue(this.defaultAddress, { emitEvent: false, onlySelf: true});
      this.addressForm.updateValueAndValidity();
    }*/
  }

  typeaheadShipperOnSelect(e: TypeaheadMatch): void {
    this.addressForm.get('uspsCity').setValue(e.item);
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value(): any {
    return this.addressForm.getRawValue();
  }

  set value(value: any) {
    this.addressForm.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(c: UntypedFormControl) {
    const addressValue = this.addressForm.getRawValue();
    const isAddressValid = this.isCountrySelectedUSA && addressValue.recordType !== 'Issue Office' ? this.addressForm.valid && addressValue.state && addressValue.zipCode && addressValue.city
      : this.addressForm.valid;
    return isAddressValid ? null : { profile: { valid: false, }, };
  }


  private addFormElement(fromElementName: string, options: any = {}) {
    if (this.addressForm.get(fromElementName)) {
      return;
    }
    this.addressForm.addControl(fromElementName,
      new UntypedFormControl(null, { ...options }));
  }

  private removeFormElement(fromElementName: string) {
    if (this.addressForm.get(fromElementName)) {
      this.addressForm.removeControl(fromElementName);
    }
  }

  private resetFormElement(fromElementName: string) {
    if (this.addressForm.get(fromElementName)) {
      this.addressForm.get(fromElementName).reset();
    }
  }

}
